import GlobalStyleComponent from "/Users/mjohnston-pm/repos/global-gatsby-iframe/src/utils/GlobalStyleComponent";
export default GlobalStyleComponent;
